// Nodejs Api's
// Local
// const MyApiUrl = 'http://localhost:7756/api/';

// const ViewImg = 'http://locahost:7756/';

// Live 
const MyApiUrl = 'https://api.libertyshieldweb.com/api/';

const ViewImg = 'https://api.libertyshieldweb.com/';

export {
  MyApiUrl,
  ViewImg,
}